<template>
  <div id="main">
    <!-- 上方導覽列 -->
    <headerBar ref="headerBar"/>
    <div class="content-page">
      <div class="content">
        <div class="container-fluid">系統登入中...</div>
      </div>
    </div>
  </div>
</template>
<script>
import headerBar from "../cathay-dashboard/header/topHeaderBar";

export default {
  components: { headerBar },
  data() {
    return {};
  },
  created() {
    this.login();
  },
  methods: {
    login() {
      this.$store.dispatch("login").then(resp => {
        if (resp) {
          if (this.$route.params.prev) {
            this.$router.push({
              name: this.$route.params.prev,
              params: this.$route.params.params
            });
          } else {
            this.$router.push({ name: this.$conf.Index });
          }
        } else {
          this.$router.push({
            name: "error",
            params: { code: 401, msg: "使用者未登入" }
          });
        }
      });
    },
    loginWithAuth() {
      this.$AuthUtils.syncUserSession().then(resp => {
        if (resp) {
          if (this.$route.params.prev) {
            this.$router.push({
              name: this.$route.params.prev,
              params: this.$route.params.params
            });
          } else {
            this.$router.push({ name: this.$conf.Index });
          }
        } else {
          this.$router.push({
            name: "error",
            params: { code: 401, msg: "使用者未登入" }
          });
        }
      });
    }
  }
};
</script>

